import { render, staticRenderFns } from "./incentive-performance-by-co.vue?vue&type=template&id=2088c2d0&"
import script from "./incentive-performance-by-co.vue?vue&type=script&lang=js&"
export * from "./incentive-performance-by-co.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports